module.exports = __webpack_public_path__ + "img/bitcoin_cuba_cryptoamigo.2d86ed06.webp";